var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Aside',[_c('b-tabs',[_c('b-tab',[_c('template',{slot:"title"},[_c('i',{staticClass:"fa fa-cog"})]),_c('AsidebarLanguage')],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }